module.exports = "#heart-logo {\n  width: 75px;\n  fill: #818181;\n  animation: beat 1s ease 0s infinite normal; }\n\n.wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  margin-top: 63px;\n  width: 85px;\n  height: 85px; }\n\n@keyframes beat {\n  0% {\n    transform: scale(1);\n    fill: #818181; }\n  50% {\n    transform: scale(1.2);\n    fill: #414141; }\n  100% {\n    transform: scale(1);\n    fill: #818181; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/LogoAnim/logoAnim.component.scss
// module id = 387
// module chunks = 1